import { Injectable } from '@angular/core';
import { ChartOptions } from 'chart.js/auto';
import { ScreenChart } from '../components/screen-chart/screen-chart';
import { Plugin } from 'chart.js/auto';
@Injectable({
  providedIn: 'root',
})
export class ChartService {
  startMarkerImage: HTMLImageElement = new Image();
  endMarkerImage: HTMLImageElement = new Image();
  readonly MARKER_SIZE: number = 28;
  readonly PADDING_SIZE: number = this.MARKER_SIZE / 2;

  startMarkerAnnotation: any = {
    type: 'label',
    xValue: 0,
    yValue: 0,
    content: this.startMarkerImage,
    width: this.MARKER_SIZE,
    height: this.MARKER_SIZE,
    clip: false,
  };

  endMarkerAnnotation: any = {
    type: 'label',
    xValue: 0,
    yValue: 0,
    content: this.endMarkerImage,
    width: this.MARKER_SIZE,
    height: this.MARKER_SIZE,
    clip: false,
  };

  public OPTIONS: ChartOptions<any> = {
    clip: false,
    spanGaps: true,
    responsive: true,
    maintainAspectRatio: false,
    animation: false,
    layout: {
      padding: {
        left: this.PADDING_SIZE,
        right: this.PADDING_SIZE,
        top: 0,
        bottom: this.PADDING_SIZE / 2,
      },
    },
    scales: {
      x: {
        display: false,
      },
      y: {
        display: false,
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      annotation: {
        clip: false,
        annotations: {
          startMarker: this.startMarkerAnnotation,
          endMarker: this.endMarkerAnnotation,
        },
      },
      tooltip: {
        enabled: false,
      },
    },
  };

  drawClientDistanceLine(self: ScreenChart): Plugin {
    const drawVerticalLine: Plugin = {
      id: 'drawVerticalLine',
      afterDraw(chart: any) {
        if (!chart.ctx) return;
        const ctx = chart.ctx;
        const labels: number[] = chart.data.labels;
        const dataPoints: number[] | undefined = chart.data.datasets[0]?.data;
        if (!labels || !dataPoints || labels.length === 0) return;

        const clientValue: number | undefined =
          self.trainingMode() === 'originalSpeed' ? self.clientTime() : self.clientDistance();
        if (clientValue === undefined) return;

        let minDiff: number = Infinity;
        let closestIndex: number = 0;
        for (let i = 0; i < labels.length; i++) {
          const diff: number = Math.abs(labels[i] - clientValue);
          if (diff < minDiff) {
            minDiff = diff;
            closestIndex = i;
          }
        }
        const d0 = chart.data.datasets[0]?.data[closestIndex];
        const meta = chart.getDatasetMeta(d0 !== null && d0 !== undefined ? 0 : 1);
        const point = meta.data[closestIndex];
        if (!point) return;

        ctx.save();
        ctx.beginPath();
        const pixelsAbove: number = 12; // Hauteur en pixels au-dessus du point
        ctx.moveTo(point.x, point.y - pixelsAbove);
        ctx.lineTo(point.x, chart.chartArea.bottom);
        ctx.lineWidth = 4;
        ctx.lineCap = 'round';
        ctx.strokeStyle = 'white';
        ctx.stroke();
        ctx.restore();
      },
    };
    return drawVerticalLine;
  }

  constructor() {
    this.startMarkerImage.src = '/images/chart_map_marker_start.svg';
    this.endMarkerImage.src = '/images/chart_map_marker_end.svg';
  }
}
